module.exports = __webpack_public_path__ + "media/day/377-aec69ca2.svg";